import { Component } from '@angular/core';

@Component({
  selector: 'app-section-titulo-incubar',
  templateUrl: './section-titulo-incubar.component.html',
  styleUrls: ['./section-titulo-incubar.component.scss'],
})
export class SectionTituloIncubarComponent {}
